import { useState } from "react";
import { useHistory } from "react-router-dom";
import Sidebar from "@/pages/sidebar/sidebar";
import ClientMainHeader from "@/pages/header";
import { CustomSelector } from "@/pages/utils/styled-select";
import { StyledInput } from "@/pages/utils/styled-input";
// import TransactionTable from "./transaction-table";
import { MainWrapper } from "@/pages/styled";
import { CardSection, OptionLabel, ToolBtn, ToolSection } from "./styled";
import { FeatureBalanceCard } from "@/pages/dashboard/styled";
import useGetClientInfo from "@/pages/dashboard/hooks/useGetClientInfo";
import { LimitedAccountWarning } from "@/components/limited-account-warning";
import { MerchantProcessingBanner } from "@/components/merchant-processing-banner";
import { useAccountBalance } from "@/hooks/account/use-account-balance";
import { exportToCsv } from "@/scripts/functions";
import { useAuth } from "@/providers/auth";
import TransactionTable from "@/components/transactions/transaction-table";
import { Button } from "@/components/ui/button-tw";

const Transactions = () => {
  const history = useHistory();
  const { userRole } = useAuth();
  const [shortCut, setShortCut] = useState("");
  const [search, setSearch] = useState("");
  const [tableExport, setTableExport] = useState([]);
  const [currentWidth, setCurrentWidth] = useState(0);
  const [dateOption, setDateOption] = useState({ label: "All", value: 99999 });
  const {
    data: balance,
    isLoading: loadingBalance,
    error: balanceError,
  } = useAccountBalance();
  const clientInfo = useGetClientInfo();

  const exportTable = (data = []) => {
    const exclude = [
      "originating_account_id",
      "destination_account_id",
      "transaction_to_user_id",
      "transaction_from_user_id",
      "pb_transaction_fee_ind",
      "counter_transaction_id",
      "baas_info",
      "user_id",
    ];
    exportToCsv(data, exclude, "Transactions");
  };

  return (
    <div>
      <Sidebar currentWidth={currentWidth} setCurrentWidth={setCurrentWidth} />
      <>
        <LimitedAccountWarning />
        <MerchantProcessingBanner />

        <MainWrapper>
          <div className="space-y-4 mb-6">
            <div className=" space-y-4">
              <div className="flex justify-between items-center mb-3">
                <div className="text-xl md:text-3xl lg:text-5xl font-medium">
                  Transactions
                </div>
                <Button onClick={() => history.push("/move-money")}>
                  Move money
                </Button>
              </div>
            </div>
          </div>
          <div>
            <CardSection>
              <FeatureBalanceCard
                status={clientInfo?.baas_status}
                balance={balance?.available_balance}
                isLoading={loadingBalance}
                error={balanceError}
              />
            </CardSection>
          </div>
          {/* <div className="flex justify-end mb-2">
            <ToolBtn onClick={() => exportTable(tableExport)}>Export</ToolBtn>
          </div> */}
          <TransactionTable />
          {/* <TransactionTable
            search={search}
            setSearch={setSearch}
            setTableExport={setTableExport}
            days={dateOption?.value}
          /> */}
        </MainWrapper>
      </>
    </div>
  );
};

export default Transactions;
